<template>
    <!-- <vue-friendly-iframe src="https://www.google.com/" @load="onLoad"></vue-friendly-iframe> -->
    <object :data="paymentUrl" width="400" height="300"
        type="text/html">
        Alternative Content
    </object>
</template>

<script>

export default {
    data() {
        return {
            paymentUrl: 'http://localhost:60833/#/CreditCardPayment?tbid=5&rsidlist=75&ccode=SGD&ppid=0f941dc6-3036-ec11-a84f-000d3aa18ba1&pcode=0f941dc6-3036-ec11-a84f-000d3aa18ba1&ptype=5&pgttype=1&amnt=150&spa=true'
        }
    },
    methods: {
        onLoad: function () {

        }
    }
}
</script>